import { render, staticRenderFns } from "./continuing-choose.vue?vue&type=template&id=61b00710&"
import script from "./continuing-choose.vue?vue&type=script&lang=js&"
export * from "./continuing-choose.vue?vue&type=script&lang=js&"
import style0 from "./continuing-choose.vue?vue&type=style&index=0&id=61b00710&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports